import { jwtDecode } from "jwt-decode";
import { filestoreOldAuth } from "@/entities/api";
import { storageOldAccessTokenName } from "@/shared/lib/session-service";
import type { ActsRegistryResponse } from "./types";

function getCurrentUserEmploymentId(): string {
  const token = localStorage.getItem(storageOldAccessTokenName);
  if (!token) return "";
  try {
    const { employmentId } = jwtDecode<{ employmentId?: string }>(token);
    return employmentId ?? "";
  } catch {
    return "";
  }
}

export async function getActsRegistry(params: {
  projectId: string;
  pageNumber: number;
  pageSize: number;
  sortField?: string;
  sortDirection?: string;
}): Promise<ActsRegistryResponse> {
  const res = await filestoreOldAuth.post<ActsRegistryResponse>(
    `/api/v1/project/${params.projectId}/registry-of-acts`,
    {
      currentUserEmploymentId: getCurrentUserEmploymentId(),
      sortField: params.sortField ?? "ACT_DATE",
      sortDirection: params.sortDirection ?? "DESC",
      pageNumber: params.pageNumber,
      pageSize: params.pageSize,
    },
  );

  return res.data;
}
